import script from "./video-form-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./video-form-drawer.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__